// Local runs use the test key from frontend/.env.development.local; production uses the live key.
export const PAYSTACK_PUBLIC_KEY =
  process.env.REACT_APP_PAYSTACK_PUBLIC_KEY || "pk_live_2e2003b743cbd616533973198e1f7e391e4c8057";

const loadScript = () =>
  new Promise((resolve, reject) => {
    if (window.PaystackPop) return resolve();
    const script = document.createElement("script");
    script.src = "https://js.paystack.co/v1/inline.js";
    script.async = true;
    script.onload = resolve;
    script.onerror = () => reject(new Error("Failed to load payment script"));
    document.body.appendChild(script);
  });

// Opens the Paystack checkout popup.
export const openPaystack = async ({ email, amountKobo, reference, metadata, onSuccess, onClose }) => {
  await loadScript();
  const handler = window.PaystackPop.setup({
    key: PAYSTACK_PUBLIC_KEY,
    email,
    amount: amountKobo,
    currency: "NGN",
    ref: reference,
    metadata,
    callback: (response) => onSuccess?.(response),
    onClose: () => onClose?.(),
  });
  handler.openIframe();
};
